var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMyPrescription = function SvgMyPrescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10h.833V8.333H10V7.5H8.333V5.833H7.5V7.5H5.833v.833H7.5V10zM14.167 12.5H5.833v.833h8.334V12.5zM11.667 15.833H5.833v.834h5.834v-.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.256 5.833L11.666.244A.828.828 0 0011.079 0H3.333A.834.834 0 002.5.833v18.334c0 .46.374.833.833.833h13.334c.46 0 .833-.374.833-.833V6.422a.828.828 0 00-.244-.589zm-5.59-4.41l4.412 4.41h-4.411v-4.41zM3.334 19.166V.833h7.5V6.25a.416.416 0 00.417.417h5.417v12.5H3.333z"
  }))));
};
export default SvgMyPrescription;